const FAULT_SCENE = {
  NOT_IMG: 0,
  ONLY_IMG: 1,
  OUT_AREA_OFF: 2,
  NOT_GO: 3,
};

export default FAULT_SCENE;

export const FAULT_CATEGORY = {
  NOT_GO: 8,
};

export const OTHER_ICON =
  'https://oho-image-cdn.51downapp.cn/common/0ceeb65343e64b11a85fcfc1ce0f7252_mini-63.png';

export const FAQS_TYPE = {
  APPEAL: 1, // 申诉
  FORGET_RETURN: 2, // 忘记还车
  CANNOT_RETURN: 5, // 无法还车
  UNLOCK_ORDER: 3, // 开锁失败仍计费
  LOCK_ORDER: 6, // 关锁后仍计费
  SCENICFORGET: 7, // 景区脚踏车忘记还车
};

export const PAGE_TYPE = {
  BEFORE_RIDE: 0,
  RIDING: 1,
  PAYMENT: 2,
  FINISH_RIDE: 3,
  SHORT_TIME: 4,
};
